
var raframe = window.document.getElementById('raframe');	
var raaConstantsobj = (raframe != null)?raframe.contentWindow.raaConstants:raaConstants;

function loadRaaCSS(){
    /*var raa_Date =  getFormattedDateOnly();
	var cssLink = window.document.createElement("link");
	cssLink.href = raaConstantsobj["SERVERURL"]+"/ralib/shopify/raa_preview.css?date="+raa_Date;
	cssLink .rel = "stylesheet"; 
	cssLink .type = "text/css";
	window.document.head.appendChild(cssLink);*/

  	var raa_Date =  getFormattedDateOnly();
	var cssLink = window.document.createElement("link");
	cssLink.href = "https://www.raashops.com/apps/enalito/ralib/shopify/signup.css?date="+raa_Date;
	cssLink .rel = "stylesheet"; 
	cssLink .type = "text/css";
	window.document.head.appendChild(cssLink);
  
	var flickityCss = window.document.createElement("link");
	flickityCss.href = "//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css";
	flickityCss .rel = "stylesheet"; 
	flickityCss .type = "text/css";
	window.document.head.appendChild(flickityCss);




	var flickityJs = document.createElement("script");
	flickityJs.type = "text/javascript";
	flickityJs.src = "//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
	window.document.head.appendChild(flickityJs); 
  
}

function showSubscriptionPopup(id,delay) {
  setTimeout(function(){
      document.getElementById(id).style.display = "block";
  },delay);

}

function getFormattedDateOnly()
{
	var formattedDate = new Date();
	var d = formattedDate.getDate();
	var m =  formattedDate.getMonth();
	m += 1;  // JavaScript months are 0-11
	
	if(d<10)
    {
       d='0'+d
	} 

	if(m<10) {
	    m='0'+m
	}

	var y = formattedDate.getFullYear();

	return d + "-" + m + "-" + y;
}

function raaFindAncestor (el, cls) {
		while ((el = el.parentElement) && !el.classList.contains(cls));
		return el;
}

function readCookie(name)
{ 		
		return (name = new RegExp('(?:^|;\\s*)' + ('' + name).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '=([^;]*)').exec(document.cookie)) && name[1];		
}

	function raaCarosoulSliderAnimate(opts)
	{
		var start = new Date;	
		var id = setInterval(function(){
			var timePassed = new Date - start;
			var progress = timePassed / opts.duration
			if(progress > 1){
				progress = 1;
			}
			var delta = opts.delta(progress);
			opts.step(delta);
			if (progress == 1){
				clearInterval(id);			
				opts.callback();
			}

		}, opts.dalay || 17);
	}
	
	function raaCarosoulSliderMovePrevious(elem)
	{		
		var raa_carosoul_slider = raaFindAncestor(elem,"raa_carosoul_slider");	
		var li_number = raa_carosoul_slider.getElementsByClassName('raa_slider_ul')[0].children.length;	
		var li_width = raa_carosoul_slider.getElementsByClassName('raa_slider_ul')[0].children[0].clientWidth;	
		var li_height = raa_carosoul_slider.getElementsByClassName('raa_slider_ul')[0].children[0].clientHeight;	
		var li_showing = parseInt(raa_carosoul_slider.getAttribute("data-showing"));
		var fixedmoves	= parseInt(raa_carosoul_slider.getAttribute("data-fixedmoves"));
		var moves	= parseInt(raa_carosoul_slider.getAttribute("data-moves"));	
		var current	= parseInt(raa_carosoul_slider.getAttribute("data-current"));	
				
		var pre_item = li_number - li_showing;								
		moves = (moves > pre_item)?pre_item : moves;
		moves = (moves > current)?current : moves;
		if(fixedmoves > 0) {
		  moves = fixedmoves;
		}
		
		raa_carosoul_slider.getElementsByClassName("raa_slider_next")[0].style.pointerEvents="auto";
		raa_carosoul_slider.getElementsByClassName("raa_slider_next")[0].style.opacity="1";
		raaCarosoulSliderAnimate({
			delay:0,			
			duration: 500,
			delta:function(p){return Math.max(0, -1 + 2 * p)},
			step:function(delta){				 
raa_carosoul_slider.getElementsByClassName('raa_slider_ul')[0].style.left = '-' + parseInt(current * li_width - delta * (li_width * moves)) + 'px';
			},
			callback:function(){
				current = current - moves;											
				if(current <= 0)
				{											
					raa_carosoul_slider.getElementsByClassName("raa_slider_pre")[0].style.pointerEvents="none";
					raa_carosoul_slider.getElementsByClassName("raa_slider_pre")[0].style.opacity="0.2";
				}	
				 raa_carosoul_slider.setAttribute("data-current",current);			
			}
		});
	}
	
	function raaCarosoulSliderMoveNext(elem)
	{		
										
		var raa_carosoul_slider = raaFindAncestor(elem,"raa_carosoul_slider");	
		raa_carosoul_slider.getElementsByClassName("raa_slider_pre")[0].style.pointerEvents="auto";
		raa_carosoul_slider.getElementsByClassName("raa_slider_pre")[0].style.opacity="1";
		
		var li_number = raa_carosoul_slider.getElementsByClassName('raa_slider_ul')[0].children.length;		
		var li_width = raa_carosoul_slider.getElementsByClassName('raa_slider_ul')[0].children[0].clientWidth;	
		var li_height = raa_carosoul_slider.getElementsByClassName('raa_slider_ul')[0].children[0].clientHeight;			
		var li_showing = parseInt(raa_carosoul_slider.getAttribute("data-showing"));
		var fixedmoves	= parseInt(raa_carosoul_slider.getAttribute("data-fixedmoves"));			
		var moves	= parseInt(raa_carosoul_slider.getAttribute("data-moves"));	
		var current	= parseInt(raa_carosoul_slider.getAttribute("data-current"));		
		var current	= (current < 0)	? 0 : current;								
		var next_item = (current == 0)?(li_number - li_showing):(li_number - (current + moves));
		moves = (next_item < moves)?next_item : moves;
		if(fixedmoves > 0) {
		  moves = fixedmoves;
		}	
										
		raaCarosoulSliderAnimate({
			delay:0,				
			duration: 500,
			delta:function(p){return Math.max(0, -1 + 2 * p)},
			step:function(delta){
raa_carosoul_slider.getElementsByClassName('raa_slider_ul')[0].style.left = '-' + parseInt(current * li_width + delta * (li_width * moves)) + 'px';
			},
			callback:function(){
				current = current + moves;		
				if(current >= li_number || li_number - current <= li_showing)
				{
					raa_carosoul_slider.getElementsByClassName("raa_slider_next")[0].style.pointerEvents="none";
					raa_carosoul_slider.getElementsByClassName("raa_slider_next")[0].style.opacity="0.2";
				}										
			   raa_carosoul_slider.setAttribute("data-current",current);	
			}
		});
	}	

	function raaCircularCarosoulSliderMoveNext(elem)
	{
		
	var raa_carosoul_slider = raaFindAncestor(elem,"raa_carosoul_slider");
	raa_carosoul_slider.getElementsByClassName("raa_slider_next")[0].style.pointerEvents="none";
	var raa_slider_ul = raa_carosoul_slider.getElementsByClassName('raa_slider_ul')[0];
	var li_number = raa_slider_ul.children.length;
	var li_width = raa_slider_ul.children[0].clientWidth;
	var li_height = raa_slider_ul.children[0].clientHeight;
	var li_showing = parseInt(raa_carosoul_slider.getAttribute("data-showing"));
	var moves	= parseInt(raa_carosoul_slider.getAttribute("data-moves"));

	raaCarosoulSliderAnimate({
		delay:0,
		duration: (700 * moves),
		delta:function(p){return Math.max(0, -1 + 2 * p)},
		step:function(delta){
			raa_slider_ul.style.left =  parseInt(0 - (delta *  (moves  * li_width))) + 'px';
		},
		callback:function(){
			raa_carosoul_slider.getElementsByClassName("raa_slider_next")[0].style.pointerEvents="auto";
			raa_carosoul_slider.getElementsByClassName("raa_slider_next")[0].style.cursor="pointer";
			raa_slider_ul.style.left = "0px";
			for(var i=0;i < moves;i++){
				var li = raa_slider_ul.removeChild(raa_slider_ul.children[0]);
				raa_slider_ul.appendChild(li);
			}
		}
	});


}

		function raaCircularCarosoulSliderMovePrevious(elem)
	{
	var raa_carosoul_slider = raaFindAncestor(elem,"raa_carosoul_slider");
	raa_carosoul_slider.getElementsByClassName("raa_slider_pre")[0].style.pointerEvents="none";
	var raa_slider_ul = raa_carosoul_slider.getElementsByClassName('raa_slider_ul')[0];
	var li_number = raa_slider_ul.children.length;
	var li_width = raa_slider_ul.children[0].clientWidth;
	var li_height = raa_slider_ul.children[0].clientHeight;
	var li_showing = parseInt(raa_carosoul_slider.getAttribute("data-showing"));
	var moves	= parseInt(raa_carosoul_slider.getAttribute("data-moves"));

	raa_slider_ul.style.left = "-"+(moves  * li_width)+"px";
	for(var i=0;i<moves;i++){
		var li = raa_slider_ul.removeChild(raa_slider_ul.children[raa_slider_ul.children.length - 1]);
		raa_slider_ul.insertBefore(li, raa_slider_ul.children[0]);
	}

	raaCarosoulSliderAnimate({
		delay:0,
		duration: (700 * moves),
		delta:function(p){return Math.max(0, -1 + 2 * p)},
		step:function(delta){
			raa_slider_ul.style.left = '-' + parseInt((moves  * li_width) - (delta *  (moves  * li_width))) + 'px';
		},
		callback:function(){
			raa_carosoul_slider.getElementsByClassName("raa_slider_pre")[0].style.pointerEvents="auto";
			raa_carosoul_slider.getElementsByClassName("raa_slider_pre")[0].style.cursor="pointer";
		}
	});
}
						
	
function raaSetUpperCarosoulSlider(){
				
		var raa_carosoul_sliders = document.getElementsByClassName("raa_carosoul_slider");
		if(raa_carosoul_sliders.length > 0)
		{
			
			for (var i = 0; i < raa_carosoul_sliders.length; i++){
				{		
				try
				{
					if(!raa_carosoul_sliders[i].hasAttribute('data-fixedmoves'))
                    {
                         raa_carosoul_sliders[i].setAttribute("data-fixedmoves",0);
                    }

					raa_carosoul_sliders[i].setAttribute("data-current",0);
				
					if(raa_carosoul_sliders[i].getElementsByClassName('raa_slider_ul').length > 0)
					{						
						var li_items = raa_carosoul_sliders[i].getElementsByClassName('raa_slider_ul')[0].children;
						var li_number = li_items.length;
						var slider_width = 0;
						var slider_wrapper_width = 0;
						var li_width = 0;
						var li_height = 0;
						var li_showing = 0;
						for (var j = 0; j < li_number; j++){	
							li_height  = li_items[j].clientHeight;			
							li_width = li_items[j].clientWidth;						
							slider_width += li_width;							
							if(raa_carosoul_sliders[i].getElementsByClassName('raa_slider_wrapper')[0].clientWidth > slider_width)
							{
								li_showing++;
								slider_wrapper_width += li_width;									
							}							
						}

						if(raa_carosoul_sliders[i].hasAttribute('data-side-arrow'))
                          {
                                 var data_side_arrow = raa_carosoul_sliders[i].getAttribute("data-side-arrow");
                                 if(data_side_arrow == "true" || data_side_arrow == true) {
                                
                                var raa_slider_pre_wrapper = raa_carosoul_sliders[i].querySelector('.raa_slider_pre_wrapper');
                                if(raa_slider_pre_wrapper != null)
                                {
                                    raa_slider_pre_wrapper.style.display = "block";
                                    raa_slider_pre_wrapper.style.position = "absolute";                    
                                    raa_slider_pre_wrapper.style.top = "110px";//((raa_carosoul_sliders[i].querySelector('.raa_slider_wrapper').clientHeight / 2)-28)+"px";
                                     raa_slider_pre_wrapper.style.padding = "5px";
                                    raa_slider_pre_wrapper.style.lineHeight = "1px";
                                    raa_slider_pre_wrapper.style.left = "0px";                                     
                                     var raa_slider_pre_wrapper_temp = raa_slider_pre_wrapper.parentNode.removeChild(raa_slider_pre_wrapper); 
                                     raa_carosoul_sliders[i].querySelector('.raa_slider_wrapper').appendChild(raa_slider_pre_wrapper_temp);                           
                                }
                                var raa_slider_next_wrapper = raa_carosoul_sliders[i].querySelector('.raa_slider_next_wrapper');
                                if(raa_slider_next_wrapper != null)
                                {
                                     raa_slider_next_wrapper.style.display = "block"; 
                                     raa_slider_next_wrapper.style.position = "absolute";                   
                                     raa_slider_next_wrapper.style.top = "110px";//((raa_carosoul_sliders[i].querySelector('.raa_slider_wrapper').clientHeight / 2)-28)+"px";
                                     raa_slider_next_wrapper.style.padding = "5px";
                                     raa_slider_next_wrapper.style.lineHeight = "1px";
                                     raa_slider_next_wrapper.style.right = "0px";


                                     var raa_slider_next_wrapper_temp = raa_slider_next_wrapper.parentNode.removeChild(raa_slider_next_wrapper); 
                                     raa_carosoul_sliders[i].querySelector('.raa_slider_wrapper').appendChild(raa_slider_next_wrapper_temp);                            
                                }
                             }
                        }		
						
						if(raa_carosoul_sliders[i].getElementsByClassName('raa_slider_wrapper')[0].clientWidth < slider_width)
						{
							
							raa_carosoul_sliders[i].getElementsByClassName('raa_slider_wrapper')[0].style.width = parseInt(slider_wrapper_width ) + 'px'; 					
						}
						if(raa_carosoul_sliders[i].getElementsByClassName('raa_slider_wrapper')[0].clientWidth > slider_width)
						{
							raa_carosoul_sliders[i].getElementsByClassName("raa_slider_pre_wrapper")[0].style.display="none";
							raa_carosoul_sliders[i].getElementsByClassName("raa_slider_next_wrapper")[0].style.display="none";
						}						
						
						raa_carosoul_sliders[i].getElementsByClassName('raa_slider_ul')[0].style.width = parseInt(slider_width) + 'px';						
						raa_carosoul_sliders[i].setAttribute("data-showing",li_showing);
						raa_carosoul_sliders[i].setAttribute("data-moves",li_showing);	
										
						// touch event code.						
						raa_carosoul_sliders[i].getElementsByClassName('raa_slider_ul')[0].addEventListener("touchstart", function(e){					
						var touchobj = e.changedTouches[0];
						var posX = touchobj.pageX;
    					var posY = touchobj.pageY;
						raaConstantsobj["RAA_TOUCH_START"] = posX;			
											
						}, false);				
										
						if (raa_carosoul_sliders[i].classList.contains('circular')) {
							raa_carosoul_sliders[i].getElementsByClassName('raa_slider_ul')[0].addEventListener("touchend", function(e){
						//e.preventDefault();
						var touchobj = e.changedTouches[0];
						var posX = touchobj.pageX;
    					var posY = touchobj.pageY;
						if(raaConstantsobj["RAA_TOUCH_START"] > posX)
						{
							if((raaConstantsobj["RAA_TOUCH_START"] - posX) > 50)
							{
								raaCircularCarosoulSliderMoveNext(e.target);

							}
						}
						else if(posX > raaConstantsobj["RAA_TOUCH_START"])
						{
							if((posX - raaConstantsobj["RAA_TOUCH_START"]) > 50)
							{
								raaCircularCarosoulSliderMovePrevious(e.target);
							}
						}
						}, false);
						}
						else
						{
						raa_carosoul_sliders[i].getElementsByClassName('raa_slider_ul')[0].addEventListener("touchend", function(e){
						//e.preventDefault();
						var touchobj = e.changedTouches[0];
						var posX = touchobj.pageX;
    					var posY = touchobj.pageY;
						if(raaConstantsobj["RAA_TOUCH_START"] > posX)
						{
							if((raaConstantsobj["RAA_TOUCH_START"] - posX) > 50)
							{
								raaCarosoulSliderMoveNext(e.target);
							}
						}
						else if(posX > raaConstantsobj["RAA_TOUCH_START"])
						{
							if((posX - raaConstantsobj["RAA_TOUCH_START"]) > 50)
							{
								raaCarosoulSliderMovePrevious(e.target);
							}
						}
						}, false);
						}
						var raa_slider_nexts= raa_carosoul_sliders[i].getElementsByClassName("raa_slider_next");
						var raa_slider_pres = raa_carosoul_sliders[i].getElementsByClassName("raa_slider_pre");
						var raa_slider_pre;
						if(raa_slider_nexts.length > 0)
						{
							if (raa_carosoul_sliders[i].classList.contains('circular')) {

							raa_carosoul_sliders[i].getElementsByClassName("raa_slider_next")[0].onclick = function(e){
								e.preventDefault();
								raaCircularCarosoulSliderMoveNext(e.target);
							};}else
								{
									raa_carosoul_sliders[i].getElementsByClassName("raa_slider_next")[0].onclick = function(e){
									e.preventDefault();
									raaCarosoulSliderMoveNext(e.target);
								};}
						}



						if(raa_slider_pres.length > 0)
						{
							if (raa_carosoul_sliders[i].classList.contains('circular')) {
								raa_carosoul_sliders[i].getElementsByClassName("raa_slider_pre")[0].onclick =  function(e){
								e.preventDefault();
								raaCircularCarosoulSliderMovePrevious(e.target);
								};}else{
							raa_carosoul_sliders[i].getElementsByClassName("raa_slider_pre")[0].style.pointerEvents="none";
							raa_carosoul_sliders[i].getElementsByClassName("raa_slider_pre")[0].style.opacity="0.2";
							raa_carosoul_sliders[i].getElementsByClassName("raa_slider_pre")[0].onclick =  function(e){
								e.preventDefault();
								raaCarosoulSliderMovePrevious(e.target)
							};
						 }
						}  
					}		
			}
			catch(err){			
					console.log("err from raa set carosoul slider : " + JSON.stringify(err.message ));
			}
		}		
		}
		
	}
	
}

var raaclient={
message:'message comes from raaclient.',
pushData:{},
getData:{},
validateEmail : function(email) {
    	var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    	return re.test(email);
},
getPushData : function(){				
		//this.pushData.url = window.location.href;			
		this.pushData.ip = raaConstantsobj["CLIENTIP"];	
		
		try{	
				loadRaaCSS();
				this.getCustomerData();	
                this.initEnalitoBot();
                //this.showEnalitoBot();
				this.getCategoryData();							
				this.getProductData();
				this.getOrderData();// comment if place order observer enable.	
				return {"getData":this.getData,"pushData":this.pushData}						
		}
		catch(err){			
				console.log("err raaclient getPushData: " + JSON.stringify(err.message ));
				return {"getData":this.getData,"pushData":this.pushData}	
		}		
},
getCustomerData:function()
	{	
	try
	{	 	
	var raa_customer = document.getElementsByClassName('raa_customer');	
		if(raa_customer.length > 0)
		{									 
			for(var i =0; i < raa_customer.length; i++)
			{		
				
				this.getData.cs = {};	
				this.pushData.cs = {};
				var customerObj = {};
				var customer = raa_customer[i];
				
				for(var j = 0; j<customer.childNodes.length; j++)
				{
					var elem = customer.getElementsByTagName('span')[j];
					if(typeof(elem) != "undefined" && typeof(elem.className) != "undefined" && elem.className=="raa_email")
					{	
						var class_name = elem.className.replace("raa_", "");
						var key_name = 'ev';//btoa(class_name);
						var key_value = btoa(elem.innerHTML);
						customerObj[key_name] = key_value;	
                        
						/*customerObj[key_name] = (class_name == "customer_id")?parseInt(key_value):key_value;	*/				
						if(elem.hasAttribute("data-key"))
						{
							this.getData.cs[key_name] = (class_name == "customer_id")?parseInt(key_value):key_value;
						}						
					}
				}	
				this.pushData.cs = customerObj; 
			}
		}
		else if(this.pushData.hasOwnProperty(raaConstantsobj["RAC"]))
		{
			if(this.validateEmail((this.pushData[raaConstantsobj["RAC"]])))
			{				
				this.pushData.cs = {};
				this.getData.cs = {};	
				var key_name = 'ev';//btoa("email");
				var key_value = btoa(raaConstantsobj["RAC"]);
				this.pushData.cs[key_name] = key_value;
				this.getData.cs[key_name] = key_value;//this.pushData[raaConstantsobj["RAC"]];
			}	
			else if(this.validateEmail(atob(this.pushData[raaConstantsobj["RAC"]])))
			{				
				this.pushData.cs = {};
				this.getData.cs = {};	
				var key_name = 'ev';//btoa("email");
				//var key_value = btoa(raaConstantsobj["RAC"]);
				this.pushData.cs[key_name] = this.pushData[raaConstantsobj["RAC"]];
				this.getData.cs[key_name] = this.pushData[raaConstantsobj["RAC"]];
			}			
		}
		}
		catch(err){			
				console.log("err from raaclient getCategoryData: " + JSON.stringify(err.message ));
		}
	},
	getCategoryData : function()
	{
	try{
		var raa_category = document.getElementsByClassName('raa_category');
		if(raa_category.length > 0)
		{
			for(var i =0; i < raa_category.length; i++)
			{
				this.getData.category = {};
				var category = raa_category[i];
				for(var j = 0; j<category.childNodes.length; j++)
				{
					var elem = category.getElementsByTagName('span')[j];
					if(typeof(elem) != "undefined" && typeof(elem.className) != "undefined")
					{
						var class_name = elem.className.replace("raa_", "");
						var data_value = elem.innerHTML;
						for (var k = 0; k < elem.childNodes.length; ++k)
						{
							if (elem.childNodes[k].nodeType === 3)
							{
								data_value = elem.childNodes[k].textContent;
							}
						}
						
						data_value = (class_name == "category_id")?parseInt(data_value):data_value;
						
						if(elem.hasAttribute("data-key"))
						{
							this.getData.category[class_name] = data_value;
						}
					}
				}
			}
		}
		}
		catch(err){
				console.log("err from raaclient getCategoryData: " + JSON.stringify(err.message ));
		}
	},
	getProductData : function()
	{		
		try
		{
		var raa_product = document.getElementsByClassName('raa_product');	
		if(raa_product.length > 0)
		{		
			
			this.getData.products = [];						
			this.pushData.product = {};
			for(var i =0; i < raa_product.length; i++)
			{
				var productObj = {};
				var product = raa_product[i];
				var getDataObjTemp = {};
				for(var j = 0; j<product.childNodes.length; j++)
				{					
					var elem = product.getElementsByTagName('span')[j];
					if(typeof(elem) != "undefined" && typeof(elem.className) != "undefined")
					{
						var class_name = elem.className.replace("raa_", "");
						if(class_name != "brand")
						{
							var data_value = elem.innerHTML;
							for (var k = 0; k < elem.childNodes.length; ++k)
							{
								if (elem.childNodes[k].nodeType === 3 || (class_name=="product_id" && elem.childNodes[k].nodeType === 1))
								{
									data_value = elem.childNodes[k].textContent;
								}
							}
							
							data_value = data_value.replace(/["']/g, "");
						    data_value = data_value.replace(/"/g, "'");
                            data_value = (class_name == "product_id" || class_name == "category_id")?parseInt(data_value):data_value;

                            productObj[class_name] = data_value;					
                            if(elem.hasAttribute("data-key"))
                            {
                                // parse int will work properly only with product id data-key other wise it will through exeption.
                                getDataObjTemp[class_name] = data_value;	
                                productObj[class_name] = data_value;						
                            }
                            
						}
					}
				}	
				
				if(this.pushData.currency.hasOwnProperty("base_currency_code"))
				{
						this.pushData.currency["convert_price"] = false;
				}
				
				this.getData.products.push(getDataObjTemp);
				this.pushData.product = productObj; 
			}
		}		
		}
		catch(err){			
				console.log("err from raaclient getProductData: " + JSON.stringify(err.message ));
		}
	},
	
	getCartData : function()
	{
		try
		{
		var cartData = [];
		var raa_cart = document.getElementsByClassName('raa_cart');	
		if(raa_cart.length > 0)
		{			
			if(raaConstantsobj["RAA_PAGEID"] == 4)
			{
				this.getData.products = [];				
			}
			
			var cart = raa_cart[0];
			var cartItems = cart.getElementsByClassName('line_item');	
			var cartData = [];
			for(var i =0; i < cartItems.length; i++)
			{			
				var getDataObjTemp = {};
				var itemObj = {};
				var cartItem = cartItems[i];												
				for(var j = 0; j<cartItem.childNodes.length; j++)
				{
					var elem = cartItem.getElementsByTagName('span')[j];
					if(typeof(elem) != "undefined" && typeof(elem.className) != "undefined")
					{
						var class_name = elem.className.replace("raa_", "")
						itemObj[class_name] = elem.innerHTML;	
						var data_value = elem.innerHTML;
						for (var k = 0; k < elem.childNodes.length; ++k)
						{
							if (elem.childNodes[k].nodeType === 3 || (class_name=="product_id" && elem.childNodes[k].nodeType === 1))
							{
								data_value = elem.childNodes[k].textContent;
							}
						}		

						data_value = data_value.replace(/["']/g, "");
						data_value = data_value.replace(/"/g, "'");		
						itemObj[class_name] = data_value;
						if(elem.hasAttribute("data-key"))
						{
							// parse int will work properly only with product id data-key other wise it will through exeption.
							getDataObjTemp[class_name] = parseInt(data_value);	
							itemObj[class_name] = parseInt(data_value);						
						}
					}
				}	
				
				if(raaConstantsobj["RAA_PAGEID"] == 4 && this.getData.hasOwnProperty("products"))
				{
					this.getData.products.push(getDataObjTemp);
				}					
				cartData.push(itemObj); 
			}
			
		}
		
		return {"getData":this.getData,"pushData":this.pushData,"cartData":cartData};	
			
	}
		catch(err){			
				console.log("err from raaclient getCartData: " + JSON.stringify(err.message ));
				return {"getData":this.getData,"pushData":this.pushData,"cartData":cartData};	
		}
	},
		
	getOrderData : function()
	{
		try
		{
		var raa_purchase_order = document.getElementsByClassName('raa_purchase_order');	
		if(raa_purchase_order.length > 0)
		{
				this.pushData.order = {};						
				var order = raa_purchase_order[0];				
				var order_info = order.getElementsByClassName('order_info');	
				if(order_info.length > 0)
				{
					this.pushData.order.info = {};	
					var info = order_info[0];
					for(var i = 0; i<info.childNodes.length; i++)
					{
						var elem = info.childNodes[i];	
						if(typeof(elem) != "undefined" && typeof(elem.className) != "undefined")
						{
							this.pushData.order.info[elem.className] = elem.innerHTML;	
						}
					}	
				}	
				
				var raa_buyer = order.getElementsByClassName('customer');	
				if(raa_buyer.length > 0)
				{
					this.pushData.customer = {};
					var buyer = raa_buyer[0];
					for(var i = 0; i<buyer.childNodes.length; i++)
					{
						var elem = buyer.childNodes[i];		
						if(typeof(elem) != "undefined" && typeof(elem.className) != "undefined")
						{
							this.pushData.customer[elem.className] = (elem.className == "customer_id")?parseInt(elem.innerHTML):elem.innerHTML;
							
						}
					}	
				}	
				
				
				var purchased_items =  order.getElementsByClassName('products');	
				if(purchased_items.length > 0)
				{
				
					purchased_items = purchased_items[0];
					this.pushData.order.products = [];
					var orderItems = purchased_items.getElementsByClassName('line_item');										 										
					for(var i =0; i < orderItems.length; i++)
					{						 
						var itemObj = {};
						var orderItem = orderItems[i];												
						for(var j = 0; j<orderItem.childNodes.length; j++)
						{
							var elem = orderItem.childNodes[j];		
							if(typeof(elem) != "undefined" && typeof(elem.className) != "undefined")
							{
								itemObj[elem.className] = (elem.className == "product_id")?parseInt(elem.innerHTML):elem.innerHTML;	
							}
						}																					
						this.pushData.order.products.push(itemObj); 						
					}	
				}
		}
		}
		catch(err){			
				console.log("err from raaclient getOrderData: " + JSON.stringify(err.message ));
		}
	},
	checkPageError : function()
	{
	},
	raaGetItems:function(dataArray)
{
setTimeout(function(){	
 try
			{	
				if(dataArray.length > 0)
					{
						
                        if(raframe != null && typeof raframe !='undefined'){
				             raframe.contentWindow.raaClosePreview("preview", raframe); 
				        }
				        else{
				          	 raaClosePreview("preview", raframe);
				        }                       

						for(var i=0; i<dataArray.length; i++)
						{
							var obj = dataArray[i];
							//send event to analytics
						    if(raframe != null && typeof raframe !='undefined'){
			                  raframe.contentWindow.raaTrigerSlotViewEvent(obj);
						    }
						    else{
						   	  raaTrigerSlotViewEvent(obj);
						    }

							var div = document.createElement("div");
                             
                            
				            /** Check Raa Preview function **/
						    if(raframe != null && typeof raframe !='undefined'){
			                  var raaHTML = raframe.contentWindow.setRaaPreviewHtml(div, obj);  
						    }
						    else{
			                  var raaHTML = setRaaPreviewHtml(div, obj); 
						    }
						   
						    if(typeof raaHTML !='undefined'){ 
						      div.innerHTML = raaHTML + decodeURIComponent(obj["html"].replace(/\+/g, ' ')); 
						    }
						    else{			   	
						   	  div.innerHTML = decodeURIComponent(obj["html"]);
						    }

						    /** End Preview Section **/

							div.innerHTML = div.innerHTML.replace("[slotid]", obj['slotid']);
							div.innerHTML = div.innerHTML.replace("[slotid_prev]", obj['slotid']);
							div.innerHTML = div.innerHTML.replace("[slotid_next]", obj['slotid']);
							var div_id = "raa_reco_" + obj["position"];							
							var reco_slot = document.getElementById(div_id);
							if(reco_slot != null)
							{                           	
                                reco_slot.appendChild(div);							
							}					
							else
							{
								console.log("raa slot : " + div_id + " not found.");
								var raa_reco_bottom = document.getElementById("raa_reco_bottom");
								if(raa_reco_bottom != null)
								{								
									raa_reco_bottom.appendChild(div);							
								}
							}
							/*var $carousel = $('#'+obj['slotid']).flickity({
							  // options
							  cellAlign: 'center',
							  contain: true,
							  wrapAround: true,
							  prevNextButtons: true,
							  percentPosition: true,
							  imagesLoaded:true,
							  pageDots: false,
							  
						    });*/
							/*Slick initialization code start*/
							var raa_main_div = document.getElementById(obj['slotid']);
							var slidesToShow = 5;
							var slidesToScroll =5;
							if(raa_main_div!=null && raa_main_div.hasAttribute('data-slidesToShow'))
							{
								slidesToShow = parseInt(raa_main_div.getAttribute("data-slidesToShow"));
							}
							if(raa_main_div!=null && raa_main_div.hasAttribute('data-slidesToScroll'))
							{
								slidesToScroll = parseInt(raa_main_div.getAttribute("data-slidesToScroll"));
							}
							
							$('#'+obj['slotid']).slick({
							  slidesToShow: slidesToShow,
							  slidesToScroll: slidesToScroll,
							  prevArrow: "#raa_slick_prev_"+obj['slotid'],
							  nextArrow: "#raa_slick_next_"+obj['slotid'],
							  dots: true
							});
							
							/*Slick initialization code end*/	
							/*if(div.getElementsByClassName('flickity-slider').length>0){
								var items = div.getElementsByClassName('flickity-slider')[0].children;
								var count = items.length;
								var showing = 0;
								var slider_width = 0;
								var item_width = 0;
								for (var j = 0; j < count; j++){	
									if(div.getElementsByClassName('flickity-slider')[0].clientWidth > slider_width )
									{
										item_width = items[j].clientWidth;	
										if(div.getElementsByClassName('flickity-slider')[0].clientWidth - slider_width >=item_width ){
											slider_width += item_width;
											showing++;
										}
									}							
								}
								if(count==showing)
								{
									$carousel.flickity('destroy');
									var $carousel1 = $('#'+obj['slotid']).flickity({
									  // options
									  cellAlign: 'center',
								  	  contain: true,
									  prevNextButtons: false,
									  percentPosition: true,
									  imagesLoaded:true,
									  pageDots: false,
									
									}).flickity('resize');;
									setTimeout(function(){$carousel1.flickity('resize');},8);
									
								}
							}*/
							
						}

                         if(raaConstantsobj['RAA_PAGEID'] == 1 && document.getElementById('shopify-section-1530609101967') != null )
				         {
				              var raa_reco_bottom = document.getElementById("raa_reco_bottom");
				            	
				              var shopify_section_1530609101967 = document.getElementById('shopify-section-1530609101967');

				              shopify_section_1530609101967.parentElement.insertBefore(raa_reco_bottom,shopify_section_1530609101967.nextSibling);
				         }
				         else if(raaConstantsobj['RAA_PAGEID'] == 2 && document.querySelector('.main.content') != null)
				         {
                              var raa_reco_bottom = document.getElementById("raa_reco_bottom");
				            
				              var mainContentDiv = document.querySelector('.main.content');

				              mainContentDiv.parentElement.insertBefore(raa_reco_bottom, mainContentDiv.nextSibling);
				         }	
                         else if((raaConstantsobj['RAA_PAGEID'] == 4 || raaConstantsobj['RAA_PAGEID'] == 10) && document.querySelector('.main.content') != null)
				         {
                              var raa_reco_bottom = document.getElementById("raa_reco_bottom");
				            
				              var mainContentDiv = document.querySelector('.main.content');

				              mainContentDiv.parentElement.insertBefore(raa_reco_bottom, mainContentDiv.nextSibling);
				         }
						 //setTimeout(function(){raaSetUpperCarosoulSlider();},1000);
					}
				}	
			
			catch(err)
			{			
				console.log("err from raaGetItems : " + JSON.stringify(err.message ));
			}	
		},100);
},
raaGetSignUpTemplates:function(dataArray)
{
	
 try
			{	
				if(dataArray.length > 0)
					{
						for(var i=0; i<dataArray.length; i++)
						{
						  var obj = dataArray[i];
                          if(obj["type"]=="embedd") {
                            
							var div = document.createElement("div");
                          	div.innerHTML = decodeURIComponent(obj["html"]);
							var div_id = "en_subscriber_box";							
							var en_subscriber_box = document.getElementById(div_id);
							if(en_subscriber_box != null)
							{                           	
                                en_subscriber_box.appendChild(div);							
							}
                          }
                          else if(obj["type"]=="popup") {
                            if(raaConstantsobj['RAA_PAGEID'] == obj["pageid"] ) {
                              if(obj["showon"]=="entry") {
                                  var en_sub_popup_close = readCookie("en_sub_popup_close-"+obj["_id"]);
                                  if(en_sub_popup_close!="true") {
                                    var div = document.createElement("div");
                                    div.innerHTML = '<div id="enalito-subscription-modal-enrty-'+obj["_id"]+'" class="enalito-modal"><div class="enalito-modal-content"><span id="enalito-popup-close" onclick="enSubscriptionPopupclose('+obj["showagain"]+',\'enalito-subscription-modal-enrty-'+obj["_id"]+'\',\''+obj["_id"]+'\');" class="enalito-close">&times;</span><div class="enalito-modal-body">'+(obj["html"])+'</div></div></div>';
                                    var en_sub_form = div.querySelectorAll("form"); 
                                    en_sub_form[0].parentNode.className += ' enalito-form-container-'+obj["_id"];
                                    document.getElementsByTagName("BODY")[0].appendChild(div);
                                    var delay = obj['delay']*1000;
                                    showSubscriptionPopup("enalito-subscription-modal-enrty-"+obj["_id"],delay);
                                    
                                  }
                              }
                              if(obj["showon"]=="exit") {
                                  var en_exit_popup_close = readCookie("en_exit_popup_close");
                                  if(en_exit_popup_close!="true") {
                                    var div = document.createElement("div");
                                    div.innerHTML = '<div id="enalito-subscription-modal-exit" class="enalito-modal"><div class="enalito-modal-content"><span id="enalito-popup-close" onclick="enSubscriptionPopupclose('+obj["showagain"]+',\'enalito-subscription-modal-exit\',\''+obj["_id"]+'\');" class="enalito-close">&times;</span><div class="enalito-modal-body">'+obj["html"]+'</div></div></div>';
                                    var en_sub_form = div.querySelectorAll("form"); 
                                    en_sub_form[0].parentNode.className += ' enalito-form-container-'+obj["_id"];
                                    document.getElementsByTagName("BODY")[0].appendChild(div);
                                  }
                              }
                              if(document.getElementsByClassName("enalito-form-container-"+obj["_id"]).length>0){
                                var div_success = document.createElement("div");
                                div_success.innerHTML = '<div id="enalito-div-success-'+obj["_id"]+'" class="enalito_thank_you" style="display: none;"><span><img src="https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/90d068d1-b4d2-4f66-be9e-d2ef070f533d/63035494e4b00f4bccae1fb5/sample-image/done.png"></span><p id="enalito-popup-response-text-'+obj["_id"]+'" class="enalito-popup-subscribe-text">Thanks for subscribing to our newsletter you should recieve a confirmation email soon.</p></div>';
                                document.getElementsByClassName("enalito-form-container-"+obj["_id"])[0].parentNode.appendChild(div_success);  
                              }
                                
                            }
                          }
						}
					}
				}	
			
			catch(err)
			{			
				console.log("err from raaGetItems : " + JSON.stringify(err.message ));
			}	
},
  initEnalitoBot:function() {
    var arr = []; // Array to hold the keys
    // Iterate over localStorage and insert the keys that meet the condition into arr
    for (var i = 0; i < localStorage.length; i++){
        if (localStorage.key(i).substring(0,12) == 'bp-chat-key-') {
            arr.push(localStorage.key(i));
            break;
        }
    }
    
    // Iterate over arr and remove the items by key
    for (var i = 0; i < arr.length; i++) {
        localStorage.removeItem(arr[i]);
    }
  	//var dev_emails = ["cGF1bEB3aW5lY2VudHJhbC5jby5ueg==","cGF1bEB3aW5lY2VudHJhbC5jby5ueg","cm9iaW5feWF0ZXNAaG90bWFpbC5jb20","Z2FicmllbGhhd2tlQGdtYWlsLmNvbQ","Z2FicmllbGhhd2tlQGdtYWlsLmNvbQ","cmFhdGVzdDFAZ21haWwuY29t","dHJhY2V5QHJjcy5jby5ueg","aXNwYWUyMkBnbWFpbC5jb20"];
  	//if(typeof this.pushData != undefined && typeof this.pushData.cs != undefined && this.pushData.cs != null && typeof this.pushData.cs.ev != undefined && dev_emails.includes(this.pushData.cs.ev))
    {
		var g_this = this;
         var script = window.document.createElement('script');
         var raa_bot_url = "https://cdn.botpress.cloud/webchat/v1/inject.js";
         script.setAttribute('src', raa_bot_url)
         window.document.head.appendChild(script);
        var raa_Date =  getFormattedDateOnly();
        setTimeout(function() {
        var en_payload = g_this.getEnalitoBotPayload();
          console.log(en_payload);
        window.botpressWebChat.init({
          "composerPlaceholder": "AI Shop Genie",
          "botConversationDescription": "Powered By EnalitoAI, Wines Division",
          "botId": "db4c0519-db3d-464e-bf88-343abe5f0e67", 
          "hostUrl": "https://cdn.botpress.cloud/webchat/v1", 
          "messagingUrl": "https://messaging.botpress.cloud", 
          "clientId": "db4c0519-db3d-464e-bf88-343abe5f0e67", 
          "webhookId": "055c3d5f-274e-4a4f-83fa-9432e9400f0e",          
          "lazySocket": true,
          "themeName": "prism",
          "frontendVersion": "v1",
          "showPoweredBy": false,
          "theme": "prism",
          "themeColor": "#2563eb",
          "botName":"AI Shop Genie",
          "avatarUrl":"https://cdn.shopify.com/s/files/1/0083/4509/2211/files/genie7.jpg?v=1694511137",
          "useSessionStorage": true,
          "enableConversationDeletion": true,
           "stylesheet":"https://www.raashops.com/cdn/shop/t/5/assets/bot.css?v=37802217138509232471694511158",
          "userData":{en:'Guest',ev:'',ei:'66d867af-f9aa-4e9f-9757-d915bc055088',type:'1'}
           })
       document.getElementById('bp-web-widget').style.zIndex ="9999999999999999999999999";
        window.botpressWebChat.onEvent(
            function (event) {
              if (event.type === 'LIFECYCLE.READY') {
                //g_this.sendEnalitoBotInitPayload(3500);
                g_this.sendEnalitoBotPayload(1);
              }
            },
            ['LIFECYCLE.READY']
          )
        },3000)
    }
	},

	showEnalitoBot : function() {
		setTimeout(function() {
	    	if(typeof window.botpressWebChat != 'undefined') {
	    		 window.botpressWebChat.sendEvent({"type":"show"});
                 
			}	
		},2000)
	},

    sendEnalitoBotInitPayload : function(delay) {
		var g_this = this;
		setTimeout(function() {
	    	if(typeof window.botpressWebChat != 'undefined' && readCookie("eninitbot")==null) {
	    		var botPayload = {};
	    		botPayload['cookie'] = "";
	    		botPayload['type'] = "init";
	    		botPayload['ev'] = "";
                botPayload['en'] = "Guest";
	    		if(typeof g_this.pushData != undefined && typeof g_this.pushData.cs != undefined && g_this.pushData.cs != null && typeof g_this.pushData.cs.ev != undefined){
					botPayload['ev'] = g_this.pushData.cs.ev;
	    		}
                if(typeof g_this.pushData != undefined && typeof g_this.pushData.cs != undefined && g_this.pushData.cs != null && typeof g_this.pushData.cs.en != undefined){
					botPayload['en'] = g_this.pushData.cs.en;
	    		}
                if(typeof g_this.pushData != undefined && typeof g_this.pushData.cs != undefined && g_this.pushData.cs != null && typeof g_this.pushData.cs.ei != undefined){
					botPayload['ei'] = g_this.pushData.cs.internalip;
	    		}
		        window.parent.botpressWebChat.sendPayload({
		            "type":"trigger",
		            payload:botPayload
		        })
              raaCreateCookies("eninitbot",1,7);
              console.log(botPayload);
			}	
		},delay)
	},

	sendEnalitoBotPayload : function(delay) {
	  var g_this = this;
      var dev_emails_names = {"cGF1bEB3aW5lY2VudHJhbC5jby5ueg":"Paul","cGF1bEB3aW5lY2VudHJhbC5jby5ueg==":"Paul","cm9iaW5feWF0ZXNAaG90bWFpbC5jb20":"Robin","Z2FicmllbGhhd2tlQGdtYWlsLmNvbQ":"Gabriel","cmFhdGVzdDFAZ21haWwuY29t":"RAA","dHJhY2V5QHJjcy5jby5ueg":"Tracey","aXNwYWUyMkBnbWFpbC5jb20":"Ispae"};
		setTimeout(function() {
	    	if(typeof window.botpressWebChat != 'undefined') {
	    		var botPayload = {};
	    		botPayload['type'] = ""+raaConstantsobj["RAA_PAGEID"];
                botPayload['ev'] = "";
                botPayload['en'] = "Guest";
	    		if(typeof g_this.pushData != undefined && typeof g_this.pushData.cs != undefined && g_this.pushData.cs != null && typeof g_this.pushData.cs.ev != undefined){
					botPayload['ev'] = g_this.pushData.cs.ev;
	    		}
                if(typeof g_this.pushData != undefined && typeof g_this.pushData.cs != undefined && g_this.pushData.cs != null && typeof g_this.pushData.cs.en != undefined){
					botPayload['en'] = g_this.pushData.cs.en;
	    		}
                if(typeof g_this.pushData != undefined && typeof g_this.pushData.internalip != undefined){
					botPayload['ei'] = g_this.pushData.internalip;
	    		}
				if((raaConstantsobj["RAA_PAGEID"]==5 || raaConstantsobj["RAA_PAGEID"]==11) && typeof g_this.getData != undefined && typeof g_this.getData.category != undefined && g_this.getData.category != null && g_this.getData.category.category_id != undefined) {
                   botPayload['category_id'] = g_this.getData.category.category_id;
                }
                else if(raaConstantsobj["RAA_PAGEID"]==3 && typeof g_this.pushData != undefined && typeof g_this.pushData.product != undefined && g_this.pushData.product != null) {
                   botPayload['product_id'] = g_this.pushData.product.product_id;
                }
                else if(raaConstantsobj["RAA_PAGEID"]==4) {
                   var all_data = g_this.getCartData();
                   if(typeof all_data.cartData != undefined){
                     botPayload['products'] = all_data.cartData;
                   }
                }
		        window.parent.botpressWebChat.sendPayload({
		            "type":"trigger",
		            payload:botPayload
		        })
               console.log(botPayload);
			}	
		},delay)
	},

  getEnalitoBotPayload : function() {
	  var g_this = this;
      var dev_emails_names = {"cGF1bEB3aW5lY2VudHJhbC5jby5ueg":"Paul","cGF1bEB3aW5lY2VudHJhbC5jby5ueg==":"Paul","cm9iaW5feWF0ZXNAaG90bWFpbC5jb20":"Robin","Z2FicmllbGhhd2tlQGdtYWlsLmNvbQ":"Gabriel","cmFhdGVzdDFAZ21haWwuY29t":"RAA","dHJhY2V5QHJjcy5jby5ueg":"Tracey","aXNwYWUyMkBnbWFpbC5jb20":"Ispae"};
          if(typeof window.botpressWebChat != 'undefined') {
              var botPayload = {};
              botPayload['type'] = ""+raaConstantsobj["RAA_PAGEID"];
              botPayload['ev'] = "";
              botPayload['en'] = "Guest";
              if(typeof g_this.pushData != 'undefined' && typeof g_this.pushData.cs != 'undefined' && g_this.pushData.cs != null && typeof g_this.pushData.cs.ev != 'undefined'){
                  botPayload['ev'] = g_this.pushData.cs.ev;
              }
              if(typeof g_this.pushData != 'undefined' && typeof g_this.pushData.cs != 'undefined' && g_this.pushData.cs != null && typeof g_this.pushData.cs.en != 'undefined'){
                  botPayload['en'] = g_this.pushData.cs.en;
              }
              if(typeof g_this.pushData != 'undefined' && typeof g_this.pushData.internalip != 'undefined'){
                  botPayload['ei'] = g_this.pushData.internalip;
              }
              if((raaConstantsobj["RAA_PAGEID"]==5 || raaConstantsobj["RAA_PAGEID"]==11) && typeof g_this.getData != 'undefined' && typeof g_this.getData.category != 'undefined' && g_this.getData.category != null && g_this.getData.category.category_id != 'undefined') {
                 botPayload['category_id'] = g_this.getData.category.category_id;
              }
              else if(raaConstantsobj["RAA_PAGEID"]==3 && typeof g_this.pushData != 'undefined' && typeof g_this.pushData.product != 'undefined' && g_this.pushData.product != null) {
                 botPayload['product_id'] = g_this.pushData.product.product_id;
              }
              else if(raaConstantsobj["RAA_PAGEID"]==4) {
                 var all_data = g_this.getCartData();
                 if(typeof all_data.cartData != undefined){
                   botPayload['products'] = all_data.cartData;
                 }
              }
            return botPayload;
          }	
	}
  
};
